import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, reactive, ref, getCurrentInstance } from 'vue'
import { Search, } from '@element-plus/icons-vue'
import type { FormInstance, } from 'element-plus'

import { teachersList } from '@/api/home'

export default /*#__PURE__*/_defineComponent({
  __name: 'school_teacher_select',
  props: {
    teacherId: { default: '' },
    visible: { type: Boolean, default: true }
  },
  emits: ['closed', 'selected'],
  setup(__props: any, { emit }) {

const props = __props;

const { proxy } = getCurrentInstance()
const { schoolId } = proxy.$store.state



const queryParams = reactive<{
  name: string
  mobile: string
  curPage: number
  pageSize: number
  schoolId: string | number
}>({
  name: '',
  mobile: '',
  curPage: 1,
  pageSize: 20,
  schoolId: schoolId
})
let list = ref([])
let total = ref(0)
const queryForm = ref<FormInstance>()


onMounted(() => {
  getList()
})



const handleClose = (formEl: FormInstance | undefined) => {
  // formEl.resetFields()
  // getList()
  emit("closed");
}

// 搜索
const handleQuery = () => {
  queryParams.curPage = 1
  getList()
}

//查询教师列表
const getList = async (curPage = undefined) => {
  queryParams.curPage = curPage ? curPage : 1
  let response = await teachersList(queryParams)
  if (response && response.code == 0) {
    const { totalCount, dataList } = response && response.data
    dataList.forEach((item, i) => {
      if (item.userId == props.teacherId) {
        item.active = true
      } else {
        item.active = false
      }
      item.index = i
    });
    list.value = dataList
    total.value = totalCount

  }
}



/**
* 设置/取消函数
*/
const handleSelect = (row) => {
  console.log(row);
  list.value[row.index].active = !row.active
  if (row.active) { //设置
    emit("selected", row.id, row.name);
  } else { //取消
    emit("selected", '', '');
  }
  emit("closed");

}




return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: "请选择教师",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (handleClose(queryForm.value))),
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: queryParams,
        ref_key: "queryForm",
        ref: queryForm,
        inline: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 10 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "姓名",
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        placeholder: "输入教师姓名",
                        modelValue: queryParams.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.name) = $event)),
                        onKeyup: _withKeys(handleQuery, ["enter","native"])
                      }, null, 8, ["modelValue", "onKeyup"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 10 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "手机号码",
                    prop: "mobile"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        placeholder: "输入教师手机号",
                        modelValue: queryParams.mobile,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.mobile) = $event)),
                        onKeyup: _withKeys(handleQuery, ["enter","native"])
                      }, null, 8, ["modelValue", "onKeyup"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        icon: _unref(Search),
                        type: "primary",
                        size: "mini",
                        onClick: handleQuery
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("搜索")
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createVNode(_component_el_table, {
        data: _unref(list),
        border: "",
        style: {"margin-bottom":"20px"},
        height: "500px",
        "header-cell-style": { background: '#FAFAFA' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "教师姓名",
            align: "center",
            prop: "name"
          }),
          _createVNode(_component_el_table_column, {
            label: "手机号",
            align: "center",
            prop: "mobile"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            width: "300"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                type: "success",
                link: "",
                size: "small",
                onClick: ($event: any) => (handleSelect(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("选择")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_el_pagination, {
        background: "",
        layout: "total, prev, pager, next",
        total: _unref(total),
        "page-size": queryParams.pageSize,
        "current-page": queryParams.curPage,
        onCurrentChange: getList
      }, null, 8, ["total", "page-size", "current-page"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})